<template>
  <div class="page-error-message">
    <div class="header">
      <ym-img v-if="type === 'loading-error'"
              class="loading-error"
              :src="require('@/assets/img/error/loading.png')"
              alt=""
      />
      <span class="hint">{{ hint }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'PageErrorMessage',
    props: {
      type: {
        type: String,
        default: 'loading-error',
      },
      hint: {
        type: String,
        default: '加载失败',
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-error-message {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @color-white;
  }

  .header {
    padding-top: 274px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .loading-error {
    width: 324px;
    height: 290px;
  }

  .hint {
    margin-top: @size-base;
    font-size: @font-size-medium;
    color: @color-text-lighter;
  }

</style>
